<template>
  <v-container fluid grid-list-lg mb-3>
    <v-layout row wrap>
      <v-flex xs12 sm6 offset-sm3>

        <h2 class="heading-2 align-left">Personal Information</h2>

        <v-alert  :value="true"  v-if="error != null" type="error" >{{ error.message }}</v-alert>
        <v-alert  :value="true"  v-if="success != null" type="success" >{{ success.message }}</v-alert>

        <v-layout justify-center column>
          <template v-if="ready">
            <v-form ref="form" v-model="valid" lazy-validation @submit="updateUser">
              <v-layout row>
                <v-flex xs12>
                  <v-text-field outline v-model="firstName" :rules="firstNameRules" label="First Name *" required ></v-text-field>
                </v-flex>

                <v-flex xs12>
                  <v-text-field outline v-model="lastName" :rules="lastNameRules" label="Last Name *" required ></v-text-field>
                </v-flex>
              </v-layout>

              <v-layout row>
                <v-flex xs12>
                  <v-text-field outline v-model="username" :rules="usernameRules" readonly label="Email *" required ></v-text-field>
                </v-flex>
              </v-layout>

              <v-layout row>
                <v-flex xs12 sm3>Date of Birth</v-flex>
                <v-flex xs12 sm3>
                  <v-select
                    :items="days"
                    label="DD"
                    v-model="dobDay"
                    :rules="dobRules"
                    required
                    outline
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm3 >
                  <v-select
                    :items="months"
                    label="MM"
                    v-model="dobMonth"
                     :rules="dobRules"
                    outline
                    required
                  ></v-select>
                  </v-flex>
                <v-flex xs12 sm3>
                  <v-select
                    :items="years"
                    label="YYYY"
                    v-model="dobYear"
                     :rules="dobRules"
                    outline
                    required
                  ></v-select>
                </v-flex>
              </v-layout>

              <v-layout row>
                
                <v-flex xs12>
                  <v-select
                    :items="genders"
                    label="Gender"
                    v-model="gender"
                    outline
                  ></v-select>
                </v-flex>
                
              
                <v-flex xs12>
                  <v-text-field outline v-model="phoneNumber" :rules="phoneRules" label="Mobile Phone Number *" ></v-text-field>
                </v-flex>
              </v-layout>

              <v-layout row align-center mx-1>
                <v-spacer />
                <button type="submit" class="button" :disabled="!valid || !ready" color="success" >Save Details</button>
              </v-layout>

            </v-form>
          </template>

          <template v-else>
            <div class="text-xs-center">
              <v-progress-circular
                :size="50"
                color="accent"
                indeterminate
              ></v-progress-circular>
            </div>
          </template>
        </v-layout>

      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'UserProfile',
  data () {
    
    return {
      ready: false,
      valid: true,
      firstNameRules: [
        v => !!v || 'First name is required'
      ],
      lastNameRules: [
        v => !!v || 'Last name is required'
      ],
      usernameRules: [
        v => !!v || 'Email address is required',
        v => /.+@.+/.test(v) || 'Email must be valid'
      ],
      phoneRules: [
        v => /^$|^\+(?:[0-9] ?){6,14}[0-9]$/.test(v) || 'Phone number must be valid and contain international dail code e.g. +447891234567'
      ],
      dobRules: [
        v => !!v || 'Date of Birth is required'
      ],
      firstName: '',
      lastName: '',
      phoneNumber: '',
      gender: '',
      username: '',
      originalEmail: '',
      dobDay: null,
      dobMonth: null,
      dobYear: null,
      error: null,
      success: null,
      loading: false,
      days: [],
      months: [],
      years: [],
      genders: ['Male', 'Female', 'Other']
    }
  },
  created () {
    // load this user's latest information
    this.$getCurrentUserAttributes().subscribe((userData) => {
      // console.log(userData)
      console.log('getting user attributes')
      this.username = userData.email
      this.firstName = userData.given_name
      this.lastName = userData.family_name
      this.phoneNumber = userData.phone_number
      this.phoneNumber = userData.phone_number
      this.originalEmail = userData.email
      this.gender = userData.gender

      var birthdayDates = userData.birthdate.split('-')
      this.dobDay = parseInt(birthdayDates[2])
      this.dobMonth = parseInt(birthdayDates[1])
      this.dobYear = parseInt(birthdayDates[0])

      // tell the app that we've finished loading
      this.ready = true
    }, 
    (err)=> {
        console.log('Unable to load user profile, session may not be present.')
    });
    
  },
  mounted (){
    this.populateDates()
  },
  methods: {
    pad (num, size) {
      var s = num+"";
      while (s.length < size) s = "0" + s;
      return s;
    },
    populateDates () {
      console.log('ADDING DATES')
      for(var d=1; d<32; d++){
        this.days.push(d)
      }
      for(var m=1; m<13; m++){
        this.months.push(m)
      }
      var thisYear = new Date().getFullYear()
      for(var y=thisYear+1; y > 1900 ; y--) {
        this.years.push(y)
      }
    },
    updateUser (e) {
        e.preventDefault()
        this.ready = false
        
        var email = this.username
        var firstName = this.firstName
        var lastName = this.lastName
        var phoneNumber = this.phoneNumber
        var gender = this.gender

        var attributesList = {
          "given_name": firstName, 
          "family_name": lastName,
          "phone_number": phoneNumber,
          "gender": gender
        }

        if(this.dobDay && this.dobMonth && this.dobYear){
          attributesList['birthdate'] = this.dobYear + '-' + this.pad(this.dobMonth, 2) + '-' + this.pad(this.dobDay, 2)
        }

        if(this.originalEmail.toLowerCase() != email.toLowerCase()){
          attributesList['email'] = email
          // trigger verification workflow
        }
        
        this.$updateAttributes(attributesList).subscribe((response) => {
          console.log("update successful")
          this.error = null
          this.success = response
          this.ready = true
        }, 
        (err)=> {
          //if we get an UnkownError it is more than likely because the user has a status of 'FORCE_CHANGE_PASSWORD' in AWS Cognito
          // console.log(err.message)
          this.success = null
          this.error = err
          this.ready = true
        });       
    }
  }
}
</script>

<style scoped>
</style>